import React from 'react';

function oldSchoolCopy(text) {
  const tempTextArea = document.createElement('textarea');
  tempTextArea.value = text;
  document.body.appendChild(tempTextArea);
  tempTextArea.select();
  document.execCommand('copy');
  document.body.removeChild(tempTextArea);
}

export default function useCopyToClipboard() {
  const [copied, setCopied] = React.useState(null);
  const [justCopied, setJustCopied] = React.useState(false);
  const timeoutIdRef = React.useRef(null);

  const resetJustCopied = ({ delay = 500 }) => {
    if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
    timeoutIdRef.current = setTimeout(() => setJustCopied(false), delay);
  };

  const copyToClipboard = React.useCallback((value) => {
    const handleCopy = async () => {
      try {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(value);
          setCopied(value);
          setJustCopied(true);
          if (timeoutIdRef.current) clearTimeout(timeoutIdRef.current);
          timeoutIdRef.current = setTimeout(() => setJustCopied(false), 2000);
        } else {
          throw new Error('writeText not supported');
        }
      } catch (e) {
        oldSchoolCopy(value);
        setCopied(value);
      }
    };

    handleCopy();
  }, []);

  return {
    copied,
    copyToClipboard,
    justCopied,
    resetJustCopied,
  };
}



// WEBPACK FOOTER //
// ./hooks/useClipboard.js